import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Street1 from '../../../../shared-components/AddressComponent/Street1/Street1';
import Street2 from '../Street2/Street2';
import City from '../../../../shared-components/AddressComponent/City/City';
import PostalCode from '../../../../shared-components/AddressComponent/PostalCode/PostalCode';
import State from '../State/State';
import Col from '../../../../shared-components/VXGrid/Col';
import Row from '../../../../shared-components/VXGrid/Row';
import { GB_COUNTRY } from '../../../config/GBConstants';

const LOCALE_PREFIX = 'GB/components/Address/Address';

export class AddressGroup extends Component {
    static propTypes = {
        ariadescribedby: PropTypes.string,
        idPrefix: PropTypes.string
    };

    render() {
        const { ariadescribedby, idPrefix } = this.props;

        return (
            <div className="addressGroup">
                <Row className="addressGroup-streetOne" gutterSize={10}>
                    <Col xs={12}>
                        <Street1 localePrefix={LOCALE_PREFIX} idPrefix={idPrefix} ariadescribedby={ariadescribedby} />
                    </Col>
                </Row>
                <Row className="addressGroup-streetTwo" gutterSize={10}>
                    <Col xs={12}>
                        <Street2 idPrefix={idPrefix} ariadescribedby={ariadescribedby} />
                    </Col>
                </Row>
                <Row className="addressGroup-streetCity" gutterSize={10}>
                    <Col xs={12}>
                        <City idPrefix={idPrefix} localePrefix={LOCALE_PREFIX} ariadescribedby={ariadescribedby} />
                    </Col>
                </Row>
                <Row className="addressGroup-CountyPostcode" gutterSize={10}>
                    <Col xs={7} className="addressGroup-State">
                        <State idPrefix={idPrefix} ariadescribedby={ariadescribedby} />
                    </Col>
                    <Col xs={5} className="addressGroup-PostalCode">
                        <PostalCode idPrefix={idPrefix} localePrefix={LOCALE_PREFIX} country={GB_COUNTRY} ariadescribedby={ariadescribedby} />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default AddressGroup;
